import axios from 'axios';

const API_URL = 'https://ai.kesifaraci.com/service/api/';



export const fetchUniversity = async () => {
    try {
      const response = await axios.get(`${API_URL}universities`, {
        
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching publication list:", error);
      throw error;
    }
  };

export const fetchUniversityDomain = async (uniid) => {
    try {
      const response = await axios.get(`${API_URL}universitieDomainList/${uniid}`, {
        
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching publication list:", error);
      throw error;
    }
  };